import React from 'react';
import { View } from 'react-native';
import { Pressable, Box, HStack, Text, useColorModeValue } from 'native-base';
import { listStyle } from 'src/styles/listStyle';
import { cardStyle } from 'src/styles/cardStyle';
import TextWithIcon from '../../TextWithIcon';
import { ISurveyor } from '../../../models/Surveyor';

interface SurveyorListItemProps {
  item: ISurveyor;
}

export default function SurveyorListItem({ item }: SurveyorListItemProps) {
  const textColor = useColorModeValue('coolGray.800', 'coolGray.100');
  const cardBgColor = useColorModeValue('coolGray.100', 'coolGray.800');
  const borderColor = useColorModeValue('coolGray.300', 'coolGray.600');

  return (
    <Pressable
      onPress={() => {
        // Add your item click logic here
      }}
      style={cardStyle.normalCard}
      rounded="8"
      overflow="hidden"
      borderWidth="1"
      borderColor={borderColor}
      shadow="3"
      bg={cardBgColor}
      p="4"
    >
      <Box>
        <View style={listStyle.cardSection}>
          <View style={{ width: "70%" }}>
            <Text color={textColor} fontSize={18} fontWeight="bold" style={listStyle.title}>
              {item.name}
            </Text>
            <HStack space={2} mt={2} flexWrap="wrap">
              <TextWithIcon icon="account" text={item.surveyorId} />
              <TextWithIcon icon="phone" text={item.phoneNumber} />
              {
                item.aadharId &&
                <TextWithIcon icon="card-account-details" text={item.aadharId} />
              }
            </HStack>
          </View>
        </View>
      </Box>
    </Pressable>
  );
}
